import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DashboardStatus } from '@shared-features/models/dashboard-status.enum.enum';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DashboardCardComponent {
  @Input() statues: DashboardStatus[];
  @Input() isMaskData: boolean;

}

